import { Injectable } from '@angular/core';
import { CodedEntity } from '@asm/features/sync/models/coded-entity.model';
import { RepositoryBase } from '@asm/features/sync/repositories/repository-base';

/** Store: `banks` | keyPath: `code` */
@Injectable({ providedIn: 'root' })
export class BankRepository extends RepositoryBase<CodedEntity> {
  protected readonly KEY_PATH = 'banks';
}
